import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { PermissionService } from '../../shared/services/permission.service';
import { stripUrlParams } from '../../shared/utils/feature-route.util';

export const permissionGuard: CanActivateFn = (route, state) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  let targetUrl = stripUrlParams(state.url);

  // Root navigation goes through the layout and then redirects to /modules.
  // If we permission-check '/' we may incorrectly deny before the redirect happens.
  if (targetUrl === '/' || targetUrl === '') {
    targetUrl = '/modules';
  }

  // Always allow the modules landing page and the under-construction page.
  if (targetUrl === '/modules' || targetUrl === '/under-construction') {
    return true;
  }

  // Ensure hierarchy permissions are available before checking IsView.
  return permissionService.loadFeatureHierarchyPermissions('WEB').pipe(
    map(loaded => {
      if (!loaded) {
        router.navigate(['/under-construction']);
        return false;
      }

      // Normalize URL for permission lookup
      const allowed = permissionService.canView(targetUrl);
      if (allowed) {
        return true;
      }

      router.navigate(['/under-construction']);
      return false;
    })
  );
};
